/**
 * Navigation Menu JavaScript
 * ナビゲーションメニューの動作制御
 */

document.addEventListener('DOMContentLoaded', function() {

    // モバイルメニューの制御
    const mobileMenuToggle = document.querySelector('.mobile-menu-toggle');
    const mobileNavContainer = document.querySelector('.mobileNav-container');
    const mobileNavOverlay = document.querySelector('.mobileNav-overlay');
    const body = document.body;

    // モバイルメニューの開閉
    if (mobileMenuToggle) {
        mobileMenuToggle.addEventListener('click', function() {
            toggleMobileMenu();
        });
    }

    // オーバーレイクリックでメニューを閉じる
    if (mobileNavOverlay) {
        mobileNavOverlay.addEventListener('click', function() {
            closeMobileMenu();
        });
    }

    // ESCキーでメニューを閉じる
    document.addEventListener('keydown', function(e) {
        if (e.key === 'Escape') {
            closeMobileMenu();
        }
    });

    // モバイルメニューのサブメニュー制御
    const mobileSubmenus = document.querySelectorAll('.mobileNav .has-submenu');
    mobileSubmenus.forEach(function(submenu) {
        const toggle = submenu.querySelector('.submenu-toggle');
        if (toggle) {
            toggle.addEventListener('click', function(e) {
                e.preventDefault();
                toggleSubmenu(submenu);
            });
        }
    });

    // ウィンドウリサイズ時の処理
    window.addEventListener('resize', function() {
        if (window.innerWidth > 768) {
            closeMobileMenu();
        }
    });

    /**
     * モバイルメニューの開閉切り替え
     */
    function toggleMobileMenu() {
        const isActive = mobileMenuToggle.classList.contains('is-active');

        if (isActive) {
            closeMobileMenu();
        } else {
            openMobileMenu();
        }
    }

    /**
     * モバイルメニューを開く
     */
    function openMobileMenu() {
        mobileMenuToggle.classList.add('is-active');
        mobileNavContainer.classList.add('is-active');
        mobileNavOverlay.classList.add('is-active');
        body.classList.add('mobile-menu-open');

        // アクセシビリティ
        mobileMenuToggle.setAttribute('aria-expanded', 'true');
        mobileNavContainer.setAttribute('aria-hidden', 'false');

        // フォーカス管理
        const firstFocusable = mobileNavContainer.querySelector('a, button, [tabindex]:not([tabindex="-1"])');
        if (firstFocusable) {
            firstFocusable.focus();
        }
    }

    /**
     * モバイルメニューを閉じる
     */
    function closeMobileMenu() {
        mobileMenuToggle.classList.remove('is-active');
        mobileNavContainer.classList.remove('is-active');
        mobileNavOverlay.classList.remove('is-active');
        body.classList.remove('mobile-menu-open');

        // アクセシビリティ
        mobileMenuToggle.setAttribute('aria-expanded', 'false');
        mobileNavContainer.setAttribute('aria-hidden', 'true');

        // サブメニューも閉じる
        const openSubmenus = mobileNavContainer.querySelectorAll('.submenu-open');
        openSubmenus.forEach(function(submenu) {
            submenu.classList.remove('submenu-open');
        });

        // フォーカスをトグルボタンに戻す
        mobileMenuToggle.focus();
    }

    /**
     * サブメニューの開閉切り替え
     */
    function toggleSubmenu(submenuItem) {
        const isOpen = submenuItem.classList.contains('submenu-open');

        // 他のサブメニューを閉じる
        const otherOpenSubmenus = document.querySelectorAll('.mobileNav .submenu-open');
        otherOpenSubmenus.forEach(function(item) {
            if (item !== submenuItem) {
                item.classList.remove('submenu-open');
            }
        });

        // 現在のサブメニューを開閉
        if (isOpen) {
            submenuItem.classList.remove('submenu-open');
        } else {
            submenuItem.classList.add('submenu-open');
        }
    }

    // スムーススクロール（アンカーリンク用）
    const anchorLinks = document.querySelectorAll('a[href^="#"]');
    anchorLinks.forEach(function(link) {
        link.addEventListener('click', function(e) {
            const href = this.getAttribute('href');

            // 空のアンカーや#のみの場合はスキップ
            if (!href || href === '#') {
                return;
            }

            const target = document.querySelector(href);
            if (target) {
                e.preventDefault();

                // モバイルメニューが開いている場合は閉じる
                if (mobileNavContainer && mobileNavContainer.classList.contains('is-active')) {
                    closeMobileMenu();
                }

                // スムーススクロール
                const headerHeight = document.querySelector('header')?.offsetHeight || 0;
                const targetPosition = target.offsetTop - headerHeight - 20;

                window.scrollTo({
                    top: targetPosition,
                    behavior: 'smooth'
                });
            }
        });
    });

    // 現在のページのメニュー項目をハイライト
    highlightCurrentPage();

    /**
     * 現在のページのメニュー項目をハイライト
     */
    function highlightCurrentPage() {
        const currentUrl = window.location.pathname;
        const menuLinks = document.querySelectorAll('.globalNav a, .mobileNav a, .footer-nav a');

        menuLinks.forEach(function(link) {
            const linkUrl = new URL(link.href).pathname;

            if (linkUrl === currentUrl) {
                link.closest('.menu-item').classList.add('is-current');
            }
        });
    }
});

// エクスポート（必要に応じて）
if (typeof module !== 'undefined' && module.exports) {
    module.exports = {
        // 必要な関数をエクスポート
    };
}
